<template>
  <div id="minimarkers" @dragover.prevent>
    <gmap-map v-if="places != null"
      ref="miniMarkers"
      :center="initialCenter"
      :zoom="initialZoom"
      :options="mapOptions"
      style="height: 100%;"
      @dragend="loadAgain"
      @maptypeid_changed="saveMapType"
      @center_changed="updateCenter"
      @zoom_changed="updateZoom"
    >

      <!-- places -->
      <markers v-for="place in leveledPlaces"
        :key="place.id"
        :type="'place'"
        :marker="place"
        :mode="mode || 'link'"
      />

      <!-- chapters -->
      <markers v-for="chapter in chapters"
        :key="chapter.id"
        :type="'chapter'"
        :marker="chapter"
      />

      <new-marker
        v-if="newMarkerPos != null && mode == 'select'"
        :type="'chapter'"
        :position="newMarkerPos"
      />

    </gmap-map>
    <span v-else-if="error == null" class="blank-content">Carregando...</span>
    <span v-else class="blank-content">Não foi possível conectar ao banco.<br>Por favor, tente mais tarde.</span>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import LogRocket from "logrocket";
import markers from "./markers.vue";
import newMarker from "./newMarker.vue";
import mapMath from "@/assets/js/mapMath";
import loads from '@/assets/js/sharedLoads';
import bus from '@/api/bus'

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  name: "minimapMarkers",
  components: {
    markers,
    newMarker
  },
  props: ["mode", "place", "chapter", "newMarker"],
  data() {
    return {
      mapOptions: {
        disableDefaultUI: true,
        gestureHandling: 'greedy',
        mapTypeControl: false,
        mapTypeControlOptions: {
          position: 3, // TOP_RIGHT
          style: 2
        },
        streetViewControl: true,
        clickableIcons: false,
        restriction: {
          latLngBounds: {
            north: 85,
            south: -85,
            east: 200,  // TODO work on longitudinal boundaries
            west: -200
          },
          strictBounds: true
        }
      },
      shape: {
        // coords: [10, 10, 10, 15, 15, 15, 15, 10],
        type: "poly"
      },
      mapObj: null,
      mapCenter: null,
      oldCenter: { lat: 0, lng: 0 },
      mapZoom: null,
      oldZoom: null,
      places: null,
      error: null,
      // userSpot: [],
      newMarkerPos: this.newMarker && this.newMarker.position
    };
  },
  computed: {
    google: gmapApi,
    initialCenter() {
      return this.paramPosition || this.currentPosition || { lat: -15.7663595475, lng: -47.8787606475 }
    },
    initialZoom() {
      return this.paramZoom || this.currentZoom || 1
    },
    currentZoom() {
      if(this.mapObj)
        return this.mapObj.zoom
      else
        return 17
    },
    paramPosition() {
      return this.$route.params.position || this.$route.params.place && this.$route.params.place.position;
    },
    paramZoom() {
      return this.$route.params.zoom || this.$route.params.place && this.$route.params.place.zoom;
    },
    leveledPlaces() {
      if (this.places.length == 1 || this.place)
        return this.places;
      let z = this.mapZoom || this.initialZoom;
      return this.places.filter(marker => {
        return [z - 1, z, z + 1].indexOf(marker.zoom) >= 0;
      });
    },
    chapters() {
      if (!this.chapter) return [];
      return Array.isArray(this.chapter)? this.chapter : [this.chapter];
    },
    currentPosition() {
      // retornar localização atual do usuário
      return null
    },
    propPlaceLength() {
      return Array.isArray(this.place) && this.place.length;
    }
  },
  asyncComputed: {
    // userPosition() {
    //   return this.geolocate().then(position => {
    //     return position;
    //   });
    // },
  },
  watch: {
    propPlaceLength() {
      this.$refs.miniMarkers.$mapPromise.then(map => {
        this.fitBounds(map, this.place);
      })
    }
  },
  mounted() {
    if (!this.place) {
      this.loadPlaces(this.paramPosition, this.paramZoom)
      .then(() => this.loadMapObj())
      .catch(error => {
        log(error, "mounted().loadPlaces()", null)
        return this.error = error;
      });
    }
    else {
      Promise.resolve(this.place)
      .then(place => Array.isArray(place) ? this.places = place : this.places = [place])
      .then(() => this.loadMapObj());
    }
    bus.on.createMarker(event => this.createMarker(event));
    bus.on.newMarker(() => this.newCenterMarker());
  },
  methods: {
    updateZoom(zoom) {
      this.oldZoom = this.mapZoom;
      this.mapZoom = zoom;
      !this.place && mapMath.zoomGroupChanged(this.oldZoom + zoom) && this.loadAgain();
      this.$emit("zoomChanged", zoom);
    },
    updateCenter(centerObj) {
      if (centerObj)
        this.mapCenter = {
          lat: centerObj.lat(),
          lng: centerObj.lng()
        }
    },
    loadPlaces(center, zoom) {
      return (this.$route.name == "home"? loads.getPlaces() : loads.loadPlaces(center, zoom))
      .then(places => this.places = places);
    },
    loadAgain() {
      if (this.place || !this.mapCenter || !this.oldCenter) return;
      let distance = mapMath.distanceFromPosition(this.mapCenter, this.oldCenter);
      let zoom = this.mapZoom || this.initialZoom;
      if (distance > mapMath.minZoomToDistance(zoom) / 2 || mapMath.zoomGroupChanged(this.oldZoom + zoom)) {
        loads.loadPlaces(this.mapCenter, zoom);
        this.oldCenter = this.mapCenter;
      }
    },
    insideMap(pos, target) {
      return target.left < pos.x && pos.x < target.right && target.top < pos.y && pos.y < target.bottom;
    },
    createMarker(event) {
      let minimap = document.getElementById("createMap");
      if (!minimap) return;
      let mapScreenPos = minimap.getBoundingClientRect();
      if (this.insideMap(event, mapScreenPos)) {
        bus.emit.position(
          this.newMarkerPos = mapMath.point2LatLng({
            x: event.x - mapScreenPos.x - 10,
            y: event.y - mapScreenPos.y
          }, this.mapObj, this.google)
        )
      }
    },
    newCenterMarker() {
      bus.emit.position(this.newMarkerPos = this.mapCenter || this.$route.params.position);
    },
    loadMapObj() {
      this.$refs.miniMarkers.$mapPromise.then(map => {
        this.mapObj = map;
        this.mapZoom = map.zoom;
        this.oldZoom = map.zoom;
        map.setMapTypeId(localStorage.getItem('mapType') || 'hybrid');
        if(this.mode == 'fixed') {
          this.mapOptions.gestureHandling = 'none';
          this.mapOptions.zoomControl = false;
          this.mapOptions.draggableCursor = 'default';
          map.setZoom(this.paramZoom);
          map.setCenter(this.paramPosition);
          map.setOptions(this.mapOptions);
          if (Array.isArray(this.place)) {
            this.fitBounds(map, this.place);
          }
        }
        if(this.place) {
          map.setZoom(this.place.zoom);
        }
      })
      .catch(err => {
        log(err, "loadMapObj()", null);
        this.error = err;
      })
    },
    map() {
      return this.$refs.miniMarkers.$mapPromise;
    },
    geolocate() {
      return new Promise((resolve, reject) => {
        if (navigator.permissions) {
          navigator.permissions
          .query({ name: "geolocation" })
          .then(permission => {
            // console.log(permission);
            if (permission.state === "granted") {
              navigator.geolocation.getCurrentPosition(position => {
                resolve({
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
                });
              }, );
            } else if(permission.state === "denied") {
              // TODO ask permission instead
              alert("Please enable geolocation!!")
              // this.$router.push({ name: "home" });
              reject(new Error("Geolocation blocked by user"))
            } else if(permission.state === "prompt") {
              reject(new Error("Waiting geolocation permission"))
            }
          });
        } else {
          navigator.geolocation.getCurrentPosition(position => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
          });
        }
      });
    },
    saveMapType(mapType) {
      localStorage.setItem('mapType', mapType);
    },
    fitBounds(map, places) {
      let bounds = new this.google.maps.LatLngBounds();
      for(let place of places) {
        bounds.extend(place.position);
      }
      map.fitBounds(bounds);
    }
    // showChapter(chapter) {
    //   if (chapter.id) {
    //     this.$router.push({ path: "/c/" + chapter.id });
    //   }
    // },
  }
};
</script>

<style lang="css" scoped>
.blank-minimap {
  background-color: #E5E3DF;
  height: inherit;
  display: flow-root;
}

.blank-content {
  margin: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.newMarker:after {
  width: 32px;
  height: 32px;
  display: block;
  content: ' ';
  position: absolute;
  top: 50%; left: 50%;
  margin: -32px 0 0 -16px;
  background: url('https://maps.google.com/mapfiles/ms/icons/green-dot.png');
  pointer-events: none;
}

/* Going against Google's Terms of Use */
/*
a[href^="http://maps.google.com/maps"]{display:none !important}
a[href^="https://maps.google.com/maps"]{display:none !important}

.gmnoprint a, .gmnoprint span, .gm-style-cc {
    display:none;
}
.gmnoprint div {
    background:none !important;
}
*/
</style>
